module.exports = __webpack_public_path__ + "7cc9e2143ec60aa3aac1e9f345b2ad4d.svg";